module.exports = __webpack_public_path__ + "img/DSC01591.553dfa62.jpeg";